module.exports = __webpack_public_path__ + "static/media/Screenshot3.b44418b7.png";